import React from "react";
import '../css/loader.css';

const loader = () => {
  return (
    <div class="lds-ring text-center">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default loader;
